import invoices from "../../asset/images/InvoiceFactoring.svg";
import trade from "../../asset/images/workingCapital.svg";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

import { useSelector } from "react-redux";

import calendar from "../../asset/images/calendar-2.svg";
import { ENDPOINTS } from "constants/endpoints";

const Credits = () => {
    const navigate = useNavigate();
    const [selectedIndex, setselectedIndex] = useState(-1);
    const [mydate, setmydate] = useState(new Date());
    const [invoice, setinvoices] = useState([]);
    const selectorbusiness = useSelector((state) => state.business);

    const [inputSearch, setinputsearch] = useState("");
    const [loaderset, setloaderset] = useState(true);
    const [tab, settab] = useState("all");
    const [maintab, setmaintab] = useState("Instruments");
    const [searchbank, setsearchbank] = useState("");
    const [show, sethsow] = useState(false);
    const [transaction, settransaction] = useState([]);
    const [shownotice, setshownotice] = useState(false);
    const [summary, setSummary] = useState([]);
    const { business } = useSelector((state) => state);
    const isBusinessApproved = business?.status === "APPROVED";

    const businessIdHeaderConfig = {
        headers: { "x-business-id": selectorbusiness?._id },
    };

    const getfinance = (index) => {
        if (!isBusinessApproved) return;
        setselectedIndex(index);
        if (index === 0) {
            navigate("/finance/invoice");
        } else if (index === 1) {
            navigate("/trade_of_credit/home");
        }
    };

    useEffect(() => {
        const fetchaccount = async () => {
            await axios
                .get(ENDPOINTS.financeAll, businessIdHeaderConfig)
                .then((res) => {
                    //console.log(res);
                    setinvoices(res.data.slice(0, 10));
                    setloaderset(false);
                })
                .catch((e) => {
                    console.log(e);
                    setloaderset(false);
                });
        };
        selectorbusiness?._d && fetchaccount();
    }, [selectorbusiness]);

    useEffect(() => {
        const fetchSummary = async () => {
            await axios
                .get(ENDPOINTS.financeSummary, businessIdHeaderConfig)
                .then((res) => {
                    setSummary(res.data);
                    //  console.log(res);
                })
                .catch((e) => {
                    setSummary([]);
                    console.log(e);
                });
        };
        selectorbusiness?._id && fetchSummary();
    }, [selectorbusiness]);
    //console.log(invoice);

    const filteredData = invoice.filter(
        (item) =>
            (item.requestedAmount && item.requestedAmount.toString().includes(inputSearch)) ||
            (item.currency && item.currency.toLowerCase().includes(inputSearch.toLowerCase())) ||
            (item.tenure && item.tenure.toString().includes(inputSearch)) ||
            (item.user && item.user.toLowerCase().includes(inputSearch.toLowerCase())) ||
            (item.invoiceType &&
                item.invoiceType.toLowerCase().includes(inputSearch.toLowerCase())) ||
            (item.paymentStatus &&
                item.paymentStatus.toLowerCase().includes(inputSearch.toLowerCase())) ||
            (item.requestTitle &&
                item.requestTitle.toLowerCase().includes(inputSearch.toLowerCase())) ||
            (item.annualRevenue && item.annualRevenue.toString().includes(inputSearch)) ||
            (item.annualTurnOver && item.annualTurnOver.toString().includes(inputSearch)) ||
            (item.businessName && item.businessName.toString().includes(inputSearch)) ||
            (item.financeType && item.financeType.toString().includes(inputSearch)) ||
            (item.loanAmount && item.loanAmount.toString().includes(inputSearch))
    );

    const filterInvoice = filteredData.filter((item) =>
        item.status?.toLowerCase()?.includes(searchbank?.toLowerCase())
    );

    invoice.sort((a, b) => a.createdAt.localeCompare(b.createdAt, "es", { sensitivity: "base" }));
    let datass = filterInvoice.reduce((r, e) => {
        let alphabet = new Date(e.createdAt).toDateString();
        if (!r[alphabet])
            r[alphabet] = {
                alphabet,
                record: [],
            };

        r[alphabet].record.push(e);
        return r;
    }, {});
    let result = Object.values(datass);
    // console.log(result);

    useEffect(() => {
        const timer = setInterval(() => {
            setmydate(new Date());
        }, 60000);
        return () => {
            clearInterval(timer);
        };
    });

    const finance = [
        {
            title: "Invoice Factoring",
            opt: "Sell your invoice for immediate cash",
            image: invoices,
        },

        {
            title: "Working Capital",
            opt: "Get a quick loan for your transaction",
            image: trade,
        },
    ];

    return (
        <div className="card border-0 min-h-[704px] rounded-[16px]">
            <div className="card-body p-[30px] flex flex-col gap-[64px]">
                <div className="row mycolumn">
                    {finance.map((finance, index) => (
                        <div className="col-md-4 col-lg-4 " key={index}>
                            <div
                                className={`card cursor-pointer p-[8px] rounded-[8px] border 
                            ${
                                !isBusinessApproved
                                    ? "opacity-50 cursor-not-allowed" // Disable styling
                                    : selectedIndex === index
                                    ? "border-[#6F00FF]"
                                    : "border-[#E7E9FB]"
                            }`}
                                onClick={() => getfinance(index)}
                            >
                                <div
                                    className="card-body"
                                    style={{
                                        padding: "10px",
                                        background: selectedIndex === index ? "#F4F0FF" : "#fff",
                                        borderRadius: "8px",
                                    }}
                                >
                                    <div className="d-flex" style={{ gap: "16px" }}>
                                        <img src={finance.image} alt="" />
                                        <div className="flex flex-col justify-between gap-2 overflow-hidden">
                                            <h1 className="font-bold text-[18px] leading-[24.3px] p-0 m-0 text-[#101828]">
                                                {finance.title}
                                            </h1>
                                            <span className="text-[14px] leading-[19.6px] font-normal text-[#667085] tracking-[-0.01em]">
                                                {finance.opt}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                <div>
                    {" "}
                    {result.length === 0 && (
                        <div className="no_invoice">
                            <div className="no_mid_invoice">
                                <h4 className="text">No finance requests yet</h4>
                                <span className="material-icons">chevron_right</span>
                            </div>
                        </div>
                    )}
                    {result.length > 0 && (
                        <div
                            className="no_invoice"
                            onClick={() => setmaintab("History")}
                            style={{ cursor: "pointer" }}
                        >
                            <div className="no_mid_invoice_lg">
                                <div className="md-invoice-lg">
                                    <h4 className="text">{invoice?.length} Request(s)</h4>
                                    <span>
                                        {summary?.totalRequests} Received,{" "}
                                        {summary?.processingRequests} Pending,{" "}
                                    </span>
                                </div>
                                <span
                                    className="material-icons"
                                    style={{
                                        color: "#0FBBE6",
                                        fontSize: "14px",
                                    }}
                                >
                                    chevron_right
                                </span>
                            </div>
                            <div className="no_mid_invoice_lg bg-[#EDFCFE] rounded-[6px] mx-[5px] flex justify-start gap-[8px]">
                                <img src={calendar} alt="" />
                                <div className="md-invoice-lg">
                                    <h4 className="text" style={{ color: "#0E84AC" }}>
                                        {summary?.dueLoans} Due
                                    </h4>
                                </div>
                            </div>
                        </div>
                    )}{" "}
                </div>
            </div>
        </div>
    );
};

export default Credits;
